export const csvKeys = [
  { title: "No.", field: "no" },
  { title: "No. pengajuan bon", field: "trx_id" },
  { title: "Tanggal Pengajuan", field: "trx_date" },
  { title: "Total bon ", field: "amount" },
  { title: "Tipe transaksi", field: "trx_type_description" },
  { title: "Deskripsi", field: "trx_text" },
  { title: "Pemohon ", field: "employee_nip" },
  { title: "NIP Pemohon", field: "employee_nip" },
  { title: "Departemen & jabatan", field: "department" },
  { title: "Segmen", field: "code_description" },
  { title: "Wilayah", field: "area_name" },
  { title: "Pool", field: "pool_id" },
  { title: "Perusahaan", field: "company_code" },
  { title: "Perusahaan relasi", field: "company_relation" },
  { title: "Akun GL", field: "trx_code" },
  { title: "Jenis transaksi Akun GL", field: "common_trx_type" },
  { title: "Deskripsi Akun GL", field: "trx_desc" },
  { title: "Rekening tujuan", field: "bank_account_name" },
  { title: "Estimasi tanggal kirim", field: "plan_postdate" },
];

export const columnOptions = [
  { label: "No. pengajuan bon", value: "trx_id", checked: true },
  { label: "Tanggal Pengajuan", value: "trx_date", checked: true },
  { label: "Total bon & tipe transaksi", value: "trx_type_description", checked: true },
  { label: "Deskripsi", value: "trx_text", checked: true },
  { label: "Pemohon & NIP", value: "employee_nip", checked: true },
  { label: "Departemen & jabatan", value: "department", checked: true },
  { label: "Segmen", value: "segment_desc", checked: true },
  { label: "Wilayah & pool", value: "area_name", checked: true },
  { label: "Perusahaan & relasi", value: "company_code", checked: true },
  { label: "Akun GL", value: "trx_code", checked: true },
  { label: "Rekening tujuan", value: "bank_account_name", checked: true },
  { label: "Estimasi tanggal kirim", value: "plan_postdate", checked: true },
  { label: "Lampiran", value: "trx_files", checked: true },
];
